/* a11y-alt-fallback.js  (v3)
   Safety net for images with no usable alt text. For any <img> whose alt is
   MISSING / EMPTY / WHITESPACE (and that isn't decorative or already named via
   aria-label), it derives alt from the nearest heading/subtitle WITHIN THE SAME
   SECTION ONLY — it never borrows a heading from another section. Falls back to
   the link/figure text, then the site name, so an alt is always present.
   Mark an image role="presentation" / aria-hidden / data-a11y-skip to keep it silent. */
(function () {
  'use strict';
  var HEAD_SEL = 'h1,h2,h3,h4,h5,h6,[class*="title"],[class*="heading"],[class*="subtitle"],[class*="subheading"]';
  var FIG_SEL = 'figure, li, [class*="item"], [class*="slide"]';
  var used = Object.create(null);
  var siteName = null;

  function getSiteName() {
    if (siteName !== null) return siteName;
    var m = document.querySelector('meta[property="og:site_name"], meta[name="og:site_name"]');
    if (m && m.getAttribute('content')) { siteName = clean(m.getAttribute('content')); return siteName; }
    if (window.Shopify && Shopify.shop) { siteName = String(Shopify.shop).replace('.myshopify.com', ''); return siteName; }
    siteName = '';
    return siteName;
  }

  function clean(s) { return (s || '').replace(/\s+/g, ' ').trim().slice(0, 125); }

  function isDecorative(img) {
    if (img.hasAttribute('data-a11y-skip')) return true;
    if (img.getAttribute('role') === 'presentation' || img.getAttribute('aria-hidden') === 'true') return true;
    if (img.closest('[aria-hidden="true"]')) return true;
    var cls = (img.className || '') + ' ' + ((img.parentElement && img.parentElement.className) || '');
    if (/(^|[\s_-])(icon|sprite|spacer|decor|pattern|swatch|divider|separator)([\s_-]|$)/i.test(cls)) return true;
    var w = img.naturalWidth || img.width || 0, h = img.naturalHeight || img.height || 0;
    if (w && h && w <= 32 && h <= 32) return true;
    return false;
  }

  /* Pick the most relevant heading inside `scope`: the last one that precedes the
     image in document order, else the first that follows. Never one containing the image. */
  function pickHeading(scope, img) {
    var nodes = scope.querySelectorAll(HEAD_SEL);
    var preceding = '', following = '';
    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i];
      if (n.contains && n.contains(img)) continue;
      if (n.closest && n.closest('[aria-hidden="true"]')) continue;
      var t = clean(n.textContent);
      if (!t) continue;
      var pos = img.compareDocumentPosition(n);
      if (pos & 2 /* DOCUMENT_POSITION_PRECEDING */) preceding = t; /* keep last preceding */
      else if (!following) following = t;
    }
    return preceding || following;
  }

  function nearestText(img) {
    /* Hard boundary: the image's own Shopify section. Never search above it. */
    var boundary = img.closest('[id^="shopify-section"]') || img.closest('section, article');
    if (boundary && boundary !== document.body && boundary !== document.documentElement) {
      var el = img.parentElement, guard = 0;
      while (el && guard < 15) {
        var t = pickHeading(el, img);
        if (t) return t;
        if (el === boundary) break;
        el = el.parentElement; guard++;
      }
    }
    /* Local fallbacks only — no page-wide heading search. */
    var fig = img.closest('figure');
    if (fig) { var fc = fig.querySelector('figcaption'); if (fc) { var c = clean(fc.textContent); if (c) return c; } }
    var a = img.closest('a');
    if (a) {
      var al = clean(a.getAttribute('aria-label')); if (al) return al;
      var ati = clean(a.getAttribute('title')); if (ati) return ati;
      var lt = clean(a.textContent); if (lt) return lt;
    }
    var ti = clean(img.getAttribute('title')); if (ti) return ti;
    return '';
  }

  function uniquify(base, img) {
    var alt = base;
    if (used[alt]) {
      var ctx = '';
      var fig = img.closest(FIG_SEL);
      if (fig && fig.parentNode) {
        var idx = Array.prototype.indexOf.call(fig.parentNode.children, fig);
        if (idx > -1) ctx = String(idx + 1);
      }
      var n = 2, cand = ctx ? (base + ' - ' + ctx) : (base + ' - ' + n);
      while (used[cand]) { n++; cand = base + ' - ' + n; }
      alt = cand;
    }
    used[alt] = true;
    return alt;
  }

  function fix(root) {
    var imgs = (root || document).querySelectorAll('img');
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      if (img.getAttribute('data-a11y-alt-set') === '1') continue;
      var cur = img.getAttribute('alt');
      if (cur !== null && cur.trim() !== '') continue;            /* already has meaningful alt */
      var named = (img.getAttribute('aria-label') || '').trim() !== '' || img.hasAttribute('aria-labelledby');
      if (named || isDecorative(img)) { img.setAttribute('alt', ''); img.setAttribute('data-a11y-alt-set', '1'); continue; }
      var base = nearestText(img) || clean(img.getAttribute('title')) || getSiteName() || 'Image';
      img.setAttribute('alt', uniquify(base, img));
      img.setAttribute('data-a11y-alt-set', '1');
    }
  }

  function init() {
    fix(document);
    if ('MutationObserver' in window) {
      var t = null;
      var mo = new MutationObserver(function (muts) {
        var run = false;
        for (var i = 0; i < muts.length; i++) { if (muts[i].addedNodes && muts[i].addedNodes.length) { run = true; break; } }
        if (run) { if (t) clearTimeout(t); t = setTimeout(function () { fix(document); }, 300); }
      });
      mo.observe(document.documentElement, { childList: true, subtree: true });
    }
    setTimeout(function () { fix(document); }, 1500);
    setTimeout(function () { fix(document); }, 4000);
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); }
  else { init(); }
})();
